//logoの表示
// 確認用：URLの末尾に「splash=1」を付けると、本日訪問済みでも毎回ローディング画面を表示します
(function() {
  var forceShow = /[?&]splash=1(&|$)/.test(window.location.search);
  var today = new Date().toISOString().slice(0, 10);
  var lastVisit = null;
  try { lastVisit = localStorage.getItem('last_visit_date'); } catch (e) {}

  // 本日すでに訪問済みなら、ローディング画面を一瞬で非表示にする（確認用URLのときは除く）
  if (!forceShow && lastVisit === today) {
    var splash = document.getElementById('splash');
    if (splash) { splash.style.display = 'none'; }
    return;
  }

  // 1回目の訪問：本日の日付を保存（確認用URLのときは保存しない）
  if (!forceShow) {
    try { localStorage.setItem('last_visit_date', today); } catch (e) {}
  }
})();

// ローディング画面を閉じる処理
// MIN_SHOW：ロゴを見せる最低時間　MAX_SHOW：通信が遅くても必ず閉じる時間　FADE_TIME：フェードアウトの時間（単位はミリ秒）
(function() {
  var MIN_SHOW = 2500;
  var MAX_SHOW = 3700;
  var FADE_TIME = 400;
  var closed = false;

  function now() {
    return (window.performance && performance.now) ? performance.now() : 0;
  }

  function closeSplash() {
    if (closed) { return; }
    closed = true;
    $("#splash").fadeOut(FADE_TIME);
  }

  // ページの骨組みが表示できたら、最低表示時間を過ぎた時点で閉じる
  $(function() {
    setTimeout(closeSplash, Math.max(0, MIN_SHOW - now()));
  });

  // 読み込みが遅い場合でも、最長時間で必ず閉じる
  setTimeout(closeSplash, Math.max(0, MAX_SHOW - now()));
})();
